import { toast } from "sonner";

export function notify(msg, type = "success") {
    if (type === "error") toast.error(msg);
    else if (type === "info") toast.info(msg);
    else toast.success(msg);
}
